import axios from 'axios';
import template from './template.twig';
import Utils from 'common/scripts/utils';

class SendFile {
    init(options) {
        this.form = options.form;
        this.fileWrapper = this.form.querySelector('.j-form-file');
        this.target = options.target;
        // флаг показывающий повторную загрузку файла
        this.retry = false;
    }

    /**
     * Метод отправляет файл
     * @param {object} file - объект из обработчика события
     */
    upload(file) {
        if (!this.retry) {
            this.file = file;
            this.fileId = Date.now();
            this._collectData('upload');
            this._paint();
        }

        axios.post('/ajax/uploadfile.php', this.formData)
            .then((response) => {
                this._setStatusLoad(response.data.data);
            })
            .catch((error) => {
                this._getElements(this.fileId);
                this._error();
                console.error(`При загрузке файла произошла ошибка: ${error}`);
            });
    }

    /**
     * Метод отправляет запрос на удаление файла
     */
    _delete() {
        this._collectData('delete');

        axios.post('/ajax/deletefile.php', this.formData)
            .then((response) => {
                this._remove(response.data.data.id);
            })
            .catch((error) => {
                console.error(`При удалении файла произошла ошибка: ${error}`);
            });
    }

    /**
     * Метод подготавливает форм-дату для отправки
     * @param {string} type - upload - загрузка файла, delete - удаление
     * @private
     */
    _collectData(type) {
        this.formData = new FormData();

        if (type === 'upload') {
            this.formData.append('id', this.fileId);
            this.formData.append('file', this.file);
        }

        if (type === 'delete') {
            this.formData.append('uid', this.uid);
            this.formData.append('id', this.fileId);
        }
    }

    /**
     * Метод отрисовывает дом элемент с результатом
     * @private
     */
    _paint() {
        const data = {};

        data.filename = this.file.name;
        data.fileId = this.fileId;

        Utils.insetContent(this.fileWrapper, template(data));
    }

    /**
     * Метод меняет статусы при загрузке файла
     * @param {object} response - ответ от сервера
     * @private
     */
    _setStatusLoad(response) {
        const id = response.id;
        const uid = response.uid;

        this._getElements(id);
        this._bindDeleteEvent();

        if (uid) {
            this._success();
            this.result.dataset.fileUid = uid;
            this._createHiddenInput(id, uid);
        } else {
            this._error();
        }
    }

    /**
     * Метод меняет статусы при удалении файла
     * @param {string} id - id элемента по которому произошел клик.
     * @private
     */
    _setStatusDelete(id) {
        this._getElements(id);
        this._process();
        this._delete();
    }

    /**
     * Метод получает необходимые дом элементы
     * @param {string} id - id необходимого блока с результатами
     * @private
     */
    _getElements(id) {
        this.result = this.fileWrapper.querySelector(`.j-form-file__result[data-file-id="${id}"]`);
        this.buttonDelete = this.result.querySelector('.j-form-file__delete');
        this.buttonRetry = this.result.querySelector('.j-form-file__retry');
        this.fileName = this.result.querySelector('.j-form-file__name');
    }

    /**
     * Метод навешивает обработчик событий на кнопку удалить.
     * @private
     */
    _bindDeleteEvent() {
        if (!this.retry) {
            this.buttonDelete.addEventListener('click', (event) => {
                event.preventDefault();
                const wrap = event.target.closest('.j-form-file__result');

                this.uid = wrap.dataset.fileUid;
                this.fileId = wrap.dataset.fileId;
                this._setStatusDelete(this.fileId);
                this._removeHiddenInput(this.fileId);
            });
        }
    }

    /**
     * Метод навешивает обработчик событий на кнопку повтороной загрузки.
     * @private
     */
    _bindRetryEvent() {
        if (!this.retry) {
            this.buttonRetry.addEventListener('click', (event) => {
                event.preventDefault();

                this.retry = true;
                this._process();
                this.upload(false);
            });
        }
    }

    /**
     * Мето меняет статус на успешный
     * @private
     */
    _success() {
        this.fileName.innerHTML = this.file.name;
        this.result.classList.remove('is-error');
        this.result.classList.add('is-success');
    }

    /**
     * Метод меняет статус на ошибку
     * @private
     */
    _error() {
        this.fileName.innerHTML = 'Не удалось загрузить файл, попробуйте ещё раз';
        this.result.classList.remove('is-success');
        this.result.classList.add('is-error');
        this._bindRetryEvent();
    }

    /**
     * Метод меняет статус на в процессе
     * @private
     */
    _process() {
        if (this.retry) {
            this.fileName.innerHTML = 'Повторная загрузка файла';
        }

        this.result.classList.remove('is-error');
        this.result.classList.remove('is-success');
    }

    /**
     * Метод удаляет элемент из дома.
     * @param {string} id - id необходимого блока с результатами
     * @private
     */
    _remove(id) {
        this._getElements(id);

        Utils.removeElement(this.result);
    }

    /**
     * Метод создает скрытый инпут для отправки uid файла с формой
     * @param {string} id - id файла
     * @param {string} uid - uid файла присвоенный сервером
     * @private
     */
    _createHiddenInput(id, uid) {
        const input = document.createElement('input');

        input.setAttribute('type', 'hidden');
        input.setAttribute('data-file-input-id', id);
        input.setAttribute('name', 'tenderFile[]');
        input.setAttribute('value', uid);

        Utils.insetContent(this.form, input);
    }

    /**
     * Метод удаляет скрытый инпут
     * @param {string} id - id файлa
     * @private
     */
    _removeHiddenInput(id) {
        const input = this.form.querySelector(`input[data-file-input-id="${id}"]`);

        Utils.removeElement(input);
    }
}

export default SendFile;
